import { IMenuItem } from 'models/IMenuItem';
import { NotifyLink } from 'components/Shared/NotifyLink';
import Image from 'components/Shared/Image';
import styles from './styles.scss';
import { getQaDataAttr } from '@bygghemmait/utilities';
import { selectBlackFridayStatus } from 'components/Header/themes/BGH/selector';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import { GtmHeaderNavClick } from 'store/googleTagManager/actions';

const itemImageSize = { width: 80, height: 80 };
export const MenuItem = (props: IMenuItem) => {
  const { id, url, ticket, image, title } = props;
  const blackFridayIsActive = useSelector(selectBlackFridayStatus);
  const reduxDispatch = useDispatch();

  const handleOnClick = () => {
    reduxDispatch(GtmHeaderNavClick(url));
  };

  return (
    <NotifyLink
      url={url}
      onClick={handleOnClick}
      ticket={ticket}
      className={cn(styles.item, { [styles.blackFriday]: blackFridayIsActive })}
      {...getQaDataAttr(`link-nav-${id}`)}
    >
      <Image
        className={cn(styles.round, { [styles.blackFriday]: blackFridayIsActive })}
        {...{ ...itemImageSize, ...image }}
        lazy
      />
      <div>{title}</div>
    </NotifyLink>
  );
};
